export default __webpack_public_path__ + "static/media/about1.61f32240.jpg";